import React from 'react'
import { createPortal } from 'react-dom'

const FullScreenLoader = () => {
  return createPortal(
    <div className="loader-container">
      <div className="loader"></div>
    </div>,
    document.body
  )
}

export default FullScreenLoader

const styles = `
  .loader-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(90 90 90 / 95%);
    z-index: 9999;
  }

  .loader {
    width: 50px;
    height: 50px;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);